import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AreaHoverState {
    isHover: boolean;
    areaIds?: string[];
}

const initialState: AreaHoverState = {
    isHover: false,
    areaIds: undefined
}

export const areaHoverSlice = createSlice({
    name: 'areaHover',
    initialState,
    reducers: {
        setAreaHover: (state, action: PayloadAction<string[]>) => {
            state.isHover = true;
            state.areaIds = action.payload
        },
        clearAreaHoverValues: (state) => {
            state.areaIds = undefined;
            state.isHover = false;
        }
    }
})

export const { setAreaHover, clearAreaHoverValues } = areaHoverSlice.actions;
export default areaHoverSlice.reducer;
export type RootState = { hover: AreaHoverState };